import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

class Typograph extends Component<IProps, any> {
    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 112 }}>
                            Font Size
                        </span>
                        <input type="number" value={descriptor.style.fontSize as number} onChange={(e) => (descriptor.style.fontSize = +e.target.value)} className={classes.input} style={{ width: 198, textAlign: 'left', borderRadius: '0px', height: '28px' }} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 112 }}>
                            Font Variant
                        </span>
                        <select type="text" value={descriptor.style.fontVariant as string} onChange={(e) => (descriptor.style.fontVariant = e.target.value)} className={classes.select} style={{ width: 205 }}>
                            ><option>normal</option>
                            <option>small-caps</option>
                        </select>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                        <span className={classes.header} style={{ width: 112 }}>
                            Font Family{' '}
                        </span>
                        <select type="text" value={descriptor.style.fontFamily as string} onChange={(e) => (descriptor.style.fontFamily = e.target.value)} className={classes.select} style={{ width: 205 }}>
                            <option>Georgia</option>
                            <option>Tahoma</option>
                            <option> Verdana</option>
                            <option>Arial</option>
                            <option>Times New Roman</option>
                            <option>Helvetica</option>
                            <option>Arial Black</option>
                            <option>Lucida Sans Unicode</option>
                            <option>Lucida Console</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(Typograph));
